module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/school-desk/school-desk.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/school-desk/school-desk.png
// module id = 624
// module chunks = 0